<template>
  <BaseAction>
    <PrimaryButton @click.native="openDialog" text>
      Add File +
    </PrimaryButton>
    <AddFileToOfferGroupDialog
      v-if="isOpen"
      @close="closeDialog"
      :offerGroupId="offerGroupId"
    />
  </BaseAction>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import BaseAction from "@/components/common/BaseAction";
import AddFileToOfferGroupDialog from "@/views/offers/dialogs/AddFileToOfferGroupDialog";

export default {
  name: "AddFileToOfferGroupAction",
  components: {
    BaseAction,
    PrimaryButton,
    AddFileToOfferGroupDialog
  },
  props: {
    offerGroupId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
